// src/modules/stores/models/store.model.ts

// ===== Store (b2b with business_model=store) =====
export interface StoreDto {
  id: string;
  name: string;
  description: string;
  owner_id: string;
  members: string[];
  logo: MediaDto | null;
  banner: MediaDto | null;
  media: MediaDto[];
  show_social: boolean;
  created_at: string;
  updated_at: string;
}

export interface MediaDto {
  key: string;
  url: string;
}

export type CreateStoreInput = {
  name: string;
  owner_id: string;
  members: string[];
  description: string;
  show_social: boolean;
};

export type UpdateStoreInput = Partial<
  Pick<StoreDto, "name" | "description" | "show_social">
>;

// ===== Shop (cửa hàng con thuộc store) =====
export interface ShopDto {
  id: string;
  name: string;
  location: string;
  b2b_id: string; // store id
  image: MediaDto | null; // logo
  banner: MediaDto | null; // banner
  is_active: boolean; // trạng thái
  created_at: string;
  updated_at: string;
}

export type CreateShopInput = {
  name: string;
  location: string;
  b2b_id: string;
  image_file?: File | null;
  image_url?: string | null;
  banner_file?: File | null;
  banner_url?: string | null;
  is_active?: boolean;
};

export type UpdateShopInput = {
  shop_id: string;
  name: string;
  location: string;
  image_file?: File | null;
  image_url?: string | null;
  banner_file?: File | null;
  banner_url?: string | null;
  is_active?: boolean;
};

// ===== Map functions =====
export const mapStoreDto = (value: unknown): StoreDto => {
  const data = (value ?? {}) as Record<string, unknown>;
  return {
    id: String(data.id ?? data._id ?? ""),
    name: String(data.name ?? ""),
    description: String(data.description ?? ""),
    owner_id: String(data.owner_id ?? data.ownerId ?? data.user_id ?? ""),
    members: Array.isArray(data.members)
      ? data.members.map(String).filter(Boolean)
      : [],
    logo: mapMediaDto(data.logo),
    banner: mapMediaDto(data.banner),
    media: Array.isArray(data.media)
      ? data.media.map(mapMediaDto).filter((m): m is MediaDto => m !== null)
      : [],
    show_social: Boolean(data.show_social ?? data.showSocial),
    created_at: String(data.created_at ?? data.createdAt ?? ""),
    updated_at: String(data.updated_at ?? data.updatedAt ?? ""),
  };
};

export const mapShopDto = (value: unknown): ShopDto => {
  const data = (value ?? {}) as Record<string, unknown>;
  return {
    id: String(data.id ?? data._id ?? ""),
    name: String(data.name ?? ""),
    location: String(data.location ?? ""),
    b2b_id: String(data.b2b_id ?? data.b2bId ?? ""),
    image: mapMediaDto(data.image),
    banner: mapMediaDto(data.banner),
    is_active: data.is_active !== undefined ? Boolean(data.is_active) : true,
    created_at: String(data.created_at ?? data.createdAt ?? ""),
    updated_at: String(data.updated_at ?? data.updatedAt ?? ""),
  };
};

export const mapMediaDto = (value: unknown): MediaDto | null => {
  if (!value) return null;
  if (typeof value === "string") return value ? { key: "", url: value } : null;
  if (typeof value !== "object") return null;
  const media = value as Record<string, unknown>;
  return {
    key: String(media.key ?? ""),
    url: String(media.url ?? ""),
  };
};
